import React, { Component } from 'react';
import LeftNavigation from '../../components/PropertyWalkThroughForm/EasyOccupantWalkThroughForm/LeftNavigation';
import DeveloperWalkthrough from '../../components/PropertyWalkThroughForm/EasyOccupantWalkThroughForm/DeveloperWalkthrough';

export default class DeveloperWalkthroughContainer extends Component {
    render () {
        return (
            <div >
            <LeftNavigation
              from={"DeveloperWalkThrough"}
              title="Easy Occupant Walk Through"
              offline={true}
              onClose={this.props.onClose}
              reduceLeftPan={ this.props.propertyWalkThroughFormData && this.props.propertyWalkThroughFormData.walkthroughType && this.props.propertyWalkThroughFormData.walkthroughType === 'Construction Walk-through' || this.props.propertyWalkThroughFormData.walkthroughType === 'Developer Walk-through' ? true : false}
              body={(
                  <DeveloperWalkthrough />
              )}
              bottom={( 
                  <div></div>
              )}
            />
          </div>
        )
    }
}